'use strict';

(function () {
    hanteraResize();

    if ('IntersectionObserver' in window && af.isTouchDevice()) {

        uppdateraByggstenarVidScroll();

        function uppdateraByggstenarVidScroll() {
            const sections = document.querySelectorAll('.byggsten-container');

            const byggstenObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('active');
                    }
                })
            }, {
                rootMargin: '-20% 0% -60% 0%'
            });

            sections.forEach(section => {
                byggstenObserver.observe(section);
            });
        }
    }

    function hanteraResize() {
        window.addEventListener('resize', resizeFunctions);
    }

    function resizeFunctions() {
        const sections = document.querySelectorAll('.byggsten-container');
        sections.forEach(section => {
            section.classList.remove('active');
        })
    }

})();
